import { Resource } from '@thiememeulenhoff/types';

export function collectQuestionsByParentId(
  parentId: string,
  resources: Array<Resource>,
): Array<Resource> {
  return resources.flatMap((resource) => {
    if (resource.parentIdentifier !== parentId) {
      return [];
    }

    if (resource.digitalResourceType === 'question') {
      return [resource];
    }

    if (resource.digitalResourceType === 'questionGroup') {
      return collectQuestionsByParentId(resource.contentIdentifier, resources);
    }

    return [];
  });
}
